'use strict';

var debounce = require('lodash/debounce');

/**
 * focuses on invalid fields from form
 * @param {string} formName name of the form containing the .is-invail elements
 */
function focusErrorElement(formName) {
    var AdyenErrorField = $('.adyen-checkout__input--error');
    if (AdyenErrorField.length < 1 && formName) {
        $('.is-invalid', $(`[name=${formName}]`))
            .attr('aria-invalid', 'true')
            .first()
            .focus();
    }
}

/**
 * handles forms for focusing on error fields
 * @param  {Object} .btn-accessibility-submit element
 */
function handleCheckoutForms(submitBtn) {
    const submitBtnClasses = (submitBtn.attr('class') || '').split(/\s+/);

    for (var form of $('form')) {
        if (submitBtnClasses.some((cls) => form.classList.contains(cls))) {
            return form.name;
        }
    }

    return '';
}

$('.btn-accessibility-submit').on(
    'click',
    debounce(function () {
        $('.is-invalid').removeAttr('aria-invalid');
        var submitButton = $(this);
        var closestForm = submitButton.closest('form');
        focusErrorElement(
            submitButton && closestForm.length > 0 ? closestForm.attr('name') : handleCheckoutForms(submitButton)
        );
    }, 300)
);
